// @ts-ignore
import { useStore } from "../stores/store";
import Keycloak, { KeycloakTokenParsed } from "keycloak-js";

/**
 * A custom hook that exposes authentication status and Keycloak instance from app store.
 *
 * @returns { authenticated: boolean; keycloakInstance: Keycloak | null; keycloakInitFailed: boolean; accessToken: string | null; tokenParsed: KeycloakTokenParsed | null }
 */
const useAuth = () => {
  const keycloakInstance = useStore(
    (state: any) => state.keycloakInstance
  ) as Keycloak | null;

  const accessToken = useStore((state: any) => state.accessToken) as
    | string
    | null;

  const authenticated =
    (useStore((state: any) => state.authenticated) as boolean) || false;

  const keycloakInitFailed = useStore(
    (state: any) => state.keycloakInitFailed
  ) as boolean;

  const tokenParsed = useStore((state: any) => state.tokenParsed) as
    | KeycloakTokenParsed
    | null;

  return {
    authenticated,
    keycloakInstance,
    accessToken,
    keycloakInitFailed,
    tokenParsed,
  };
};

export default useAuth;
